module.exports = __webpack_public_path__ + "static/logo-9fd0846a1c73cfc83e2594bd829a1de7.png";